/* torras-video-feature.js —— 从 sections/torras-video-feature.liquid 的内联 <script> 原样外置。
 * 内容与原内联块逐字节一致。搬迁后必须验该 section 的 init 哨兵是否仍被置位 ——
 * markup 由 Liquid 服务端渲染，JS 不执行时像素与 DOM 判据都不会变红。
 * 回退：把本文件内容贴回 section 内联即可。
 */
  (function () {
    function initVF(root) {
      if (!root || root.dataset.vfInit === '1') return;
      root.dataset.vfInit = '1';

      // Facts popup wires before the player guard below — it must work even
      // when the section has no video blocks.
      var factsDialog = root.querySelector('[data-vf-facts]');
      var factsOpen = root.querySelector('[data-vf-facts-open]');
      if (factsDialog && factsOpen) {
        var factsClose = factsDialog.querySelector('[data-vf-facts-close]');
        factsOpen.addEventListener('click', function () {
          if (typeof factsDialog.showModal === 'function') factsDialog.showModal();
          else factsDialog.setAttribute('open', '');
        });
        if (factsClose) factsClose.addEventListener('click', function () { factsDialog.close(); });
        factsDialog.addEventListener('click', function (e) { if (e.target === factsDialog) factsDialog.close(); });
      }

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vf-tab]'));
      var stage = root.querySelector('[data-vf-stage]');
      var dialog = root.querySelector('[data-vf-dialog]');
      var player = root.querySelector('[data-vf-player]');
      var closeBtn = root.querySelector('[data-vf-close]');
      if (!tabs.length || !stage || !dialog || !player) return;

      var active = tabs[0];

      // Mirrors the ≤720px breakpoint that hides the stage — with no stage
      // visible, tapping a card must open the player directly.
      var mqMobile = window.matchMedia('(max-width: 720px)');

      // requestIdleCallback is shimmed globally for Safari in snippets/torras-utils.liquid.
      var idle = window.requestIdleCallback;

      function ytId(url) {
        if (!url) return '';
        var m = url.match(/(?:youtu\.be\/|v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{6,})/);
        return m ? m[1] : '';
      }

      // Warm up the network for the active clip while the main thread is idle,
      // so the dialog starts playing faster on click. We only open connections
      // (preconnect) / hint metadata — no iframe or full media is loaded.
      var warmed = {};
      function addHint(rel, href, asAttr) {
        if (!href || warmed[rel + href]) return;
        warmed[rel + href] = true;
        var l = document.createElement('link');
        l.rel = rel;
        l.href = href;
        l.crossOrigin = 'anonymous';
        if (asAttr) l.as = asAttr;
        document.head.appendChild(l);
      }
      function origin(url) {
        try { return new URL(url, location.href).origin; } catch (e) { return ''; }
      }
      // CWV: warming is intent-gated. syncStage() used to call warm() during
      // init, so every homepage view opened four YouTube/Google sockets (DNS +
      // TCP + TLS each) whether or not the visitor ever scrolled to the video —
      // pure wasted radio time on mobile. Now the first pointer/focus/touch on
      // the section (or a tab click) arms it. The prefetch of the whole video
      // file is gone too; the preconnect is what actually buys the latency.
      var warmArmed = false;
      function warm(tab) {
        if (!warmArmed || !tab) return;
        var d = tab.dataset;
        idle(function () {
          if (d.vfType === 'youtube') {
            addHint('preconnect', 'https://www.youtube-nocookie.com');
            addHint('preconnect', 'https://www.youtube.com');
            addHint('preconnect', 'https://i.ytimg.com');
            addHint('preconnect', 'https://www.google.com');
          } else if (d.vfSrc) {
            var o = origin(d.vfSrc);
            if (o) addHint('preconnect', o);
          }
        });
      }
      function armWarm() {
        if (warmArmed) return;
        warmArmed = true;
        warm(active);
      }

      function syncStage(tab) {
        active = tab;
        var d = tab.dataset;
        var poster = root.querySelector('[data-vf-stage-poster]');
        poster.style.backgroundImage = d.vfPoster ? "url('" + d.vfPoster + "')" : 'none';

        root.querySelector('[data-vf-stage-title]').textContent = d.vfTitle || '';
        root.querySelector('[data-vf-stage-subtitle]').textContent = d.vfSubtitle || '';

        var badge = root.querySelector('[data-vf-stage-badge]');
        if (d.vfBadge) {
          root.querySelector('[data-vf-stage-badge-text]').textContent = d.vfBadge;
          badge.hidden = false;
        } else { badge.hidden = true; }

        var dur = root.querySelector('[data-vf-stage-dur]');
        if (d.vfDur) { dur.textContent = d.vfDur; dur.hidden = false; }
        else { dur.hidden = true; }

        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        warm(tab);
      }

      function openPlayer() {
        var d = active.dataset;
        var src = d.vfSrc;
        if (!src) return;
        var html = '';
        if (d.vfType === 'youtube') {
          var id = ytId(src);
          if (!id) return;
          var u = 'https://www.youtube-nocookie.com/embed/' + id +
            '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
          html = '<iframe src="' + u + '" title="' + (d.vfTitle || 'Product video') + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
        } else {
          html = '<video src="' + src + '" controls autoplay playsinline></video>';
        }
        player.innerHTML = html;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }

      function closePlayer() {
        if (dialog.open && typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        player.innerHTML = '';
      }

      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
        root.addEventListener(ev, armWarm, { passive: true, once: true });
      });

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var wasActive = tab === active;
          armWarm();
          syncStage(tab);
          if (wasActive || mqMobile.matches) openPlayer(); // desktop: click the already-selected tab → play; mobile: tap → play
        });
      });

      stage.addEventListener('click', openPlayer);
      if (closeBtn) closeBtn.addEventListener('click', closePlayer);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) closePlayer(); });
      dialog.addEventListener('close', function () { player.innerHTML = ''; });

      syncStage(active);
    }

    function boot() {
      document.querySelectorAll('[data-vf-root]').forEach(initVF);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-vf-root]');
      if (r) initVF(r);
    });
  })();
